/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type Organization = {
  /**
   * The account type of the organization
   */
  accountType: string;
  /**
   * The creation date of the organization.
   */
  createdAt: Date;
  /**
   * The ID of the organization
   */
  id: string;
  /**
   * The name of the organization
   */
  name: string;
  /**
   * A short url-friendly label that uniquely identifies a resource.
   */
  slug: string;
  /**
   * The last update date of the organization.
   */
  updatedAt: Date;
  /**
   * Whether webhooks are enabled for the organization
   */
  webhooksEnabled: boolean;
  /**
   * Whether webhooks support is initialized for the organization
   */
  webhooksOnboarded: boolean;
};

/** @internal */
export const Organization$inboundSchema: z.ZodMiniType<Organization, unknown> =
  z.pipe(
    z.object({
      account_type: z.string(),
      created_at: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
      id: z.string(),
      name: z.string(),
      slug: z.string(),
      updated_at: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
      webhooks_enabled: z.boolean(),
      webhooks_onboarded: z.boolean(),
    }),
    z.transform((v) => {
      return remap$(v, {
        "account_type": "accountType",
        "created_at": "createdAt",
        "updated_at": "updatedAt",
        "webhooks_enabled": "webhooksEnabled",
        "webhooks_onboarded": "webhooksOnboarded",
      });
    }),
  );

export function organizationFromJSON(
  jsonString: string,
): SafeParseResult<Organization, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Organization$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Organization' from JSON`,
  );
}
